import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h, VNode } from 'preact';

import PureComponent from './PureComponent';

import formatPercent from '../utils/format-percent';
import { isCanvass } from '../endpoints';
import PartyPill from './PartyPill';
import { lookup } from '../photoMap';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  isIncumbent: boolean;
  isWinner: boolean;
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class HeadshotCandidateRow extends PureComponent<Props> {
  static columnCount: number;
  static Header: VNode;
  static HomepageHeader: VNode;

  render() {
    const {
      ballotName,
      candidateId,
      contestIsCalled,
      isIncumbent,
      isWinner,
      party,
      isViewable,
      totalVotesInContest,
      votes,
    } = this.props;

    const IsDroppedOut =
      ballotName == 'Julián Castro' ||
      ballotName == 'Cory Booker' ||
      ballotName == 'Marianne Williamson' ||
      ballotName == 'John K. Delaney' ||
      ballotName == 'Deval Patrick' ||
      ballotName == 'Andrew Yang' ||
      ballotName == 'Michael Bennet' ||
      ballotName == 'Pete Buttigieg' ||
      ballotName == 'Tom Steyer' ||
      ballotName == 'Amy Klobuchar'
        ? true
        : false;

    let rowClass = cx(
      'candidate',
      'contest__candidate-row',
      'contest__candidate-row--headshot',
      {
        'contest__candidate-row--winner dem--border':
          contestIsCalled && isWinner && party == 'Democrat',
        'contest__candidate-row--winner rep--border':
          contestIsCalled && isWinner && party == 'Republican',
      }
    );

    let checkClass = cx('check', {
      'dem-winner': party == 'Democrat',
      'rep-winner': party == 'Republican',
      'lib-winner': party == 'Libertarian',
      'ind-winner': party == 'Independent',
      'gre-winner': party == 'Green',
    });

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          <PartyPill party={party} />
        </td>
        <th class="candidate__cell candidate__name">
          {isCanvass == true && contestIsCalled && isWinner && (
            <span class={checkClass}>{checkmark}</span>
          )}
          {isCanvass == true && contestIsCalled && isWinner ? (
            <span class={checkClass}>{ballotName}</span>
          ) : (
            ballotName
          )}
          {IsDroppedOut && <span class="dropped_out">*</span>}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
        <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
        <td class="candidate__cell candidate__pct">
          {formatPercent(votes, totalVotesInContest)}
          <span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    );
  }
}

HeadshotCandidateRow.defaultProps = {
  isIncumbent: false,
  isCalled: false,
  isWinner: false,
  isViewable: true,
};

HeadshotCandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.HomepageHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        President
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.columnCount = 6;

export default HeadshotCandidateRow;
